import { SxProps, Theme } from '@mui/material';

export const mergeSx = (...styles: Array<SxProps<Theme> | false | '' | null | undefined>): SxProps<Theme> => {
  const filteredStyles = styles.filter(Boolean) as SxProps<Theme>[];

  if (filteredStyles.length === 0) {
    return {};
  }

  if (filteredStyles.length === 1) {
    return filteredStyles[0];
  }

  return filteredStyles.flatMap((style) => (Array.isArray(style) ? style : [style]));
};

/** A CSS colour taken from a custom property at the given opacity, e.g. `cssVarMix('--accent', 40)`. */
export const cssVarMix = (variable: `--${string}`, percent: number) =>
  `color-mix(in srgb, var(${variable}) ${percent}%, transparent)`;
